import React from "react";

import styles from "./passport-modal.module.scss";
import { getPassportStatusLabelFromEnumKey } from "../../constants/passportStatus";

import Overlay from "sulu-admin-bundle/components/Overlay/Overlay.js";
import DatePicker from "sulu-admin-bundle/components/DatePicker/DatePicker.js";
import Input from "sulu-admin-bundle/components/Input";
import Loader from "sulu-admin-bundle/components/Loader";

const Modal = ({ isOpen, closeHandler, passportItem, loading }) => {
    return (
        <Overlay
            open={isOpen}
            onClose={() => closeHandler()}
            title="Passport Info"
            footer={false}
            onConfirm={closeHandler}
            confirmText="Close"
        >
            {loading ? (
                <Loader />
            ) : (
                <div className={styles["modal"]}>
                    {passportItem?.error ? (
                        <div>{passportItem.error}</div>
                    ) : (
                        <>
                            <h2 className={styles["modal__title"]}>
                                {passportItem?.firstName}{" "}
                                {passportItem?.lastName}
                            </h2>

                            <div className={styles["modal__upper"]}>
                                <div
                                    className={
                                        styles["modal__upper-image-wrap"]
                                    }
                                >
                                    <img
                                        src={
                                            passportItem?.photo?.thumbnails[
                                                "image-150.jpg"
                                            ]
                                        }
                                        className={styles["modal__upper-image"]}
                                    />
                                </div>
                                <div className={styles["modal__upper-fields"]}>
                                    <div
                                        className={
                                            styles["modal__field-wrapper"]
                                        }
                                    >
                                        <span>Date of Birth:</span>
                                        <DatePicker
                                            value={
                                                passportItem?.birthday
                                                    ? new Date(
                                                          passportItem.birthday
                                                      )
                                                    : null
                                            }
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={
                                            styles["modal__field-wrapper"]
                                        }
                                    >
                                        <span>Passport Number</span>
                                        <Input
                                            value={passportItem?.passportNumber}
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={
                                            styles["modal__field-wrapper"]
                                        }
                                    >
                                        <span>Club</span>
                                        <div
                                            className={
                                                styles[
                                                    "modal__field-club-wrapper"
                                                ]
                                            }
                                        >
                                            <img
                                                src={
                                                    passportItem?.clubLogo
                                                        ?.thumbnails[
                                                        "sulu-50x50.jpg"
                                                    ]
                                                }
                                                className={
                                                    styles["modal__field-image"]
                                                }
                                            />
                                            <Input
                                                value={
                                                    passportItem?.currentlyAssignedClub
                                                }
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles["modal__bottom"]}>
                                <div className={styles["modal__bottom-fields"]}>
                                    <div
                                        className={
                                            styles["modal__field-wrapper"]
                                        }
                                    >
                                        <span>Passport Type</span>
                                        <Input
                                            value={passportItem?.name}
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={
                                            styles["modal__field-wrapper"]
                                        }
                                    >
                                        <span>Type (abbr):</span>
                                        <Input
                                            value={passportItem?.abbreviation}
                                            disabled
                                        />
                                    </div>
                                    <div
                                        className={
                                            styles["modal__field-wrapper"]
                                        }
                                    >
                                        <span>Status:</span>
                                        <Input
                                            value={getPassportStatusLabelFromEnumKey(passportItem?.status)}
                                            disabled
                                        />
                                    </div>
                                </div>

                                <div className={styles["modal__bottom-fields"]}>
                                    <div>
                                        <span>Valid from:</span>
                                        <DatePicker
                                            value={
                                                passportItem?.validFrom
                                                    ? new Date(
                                                          passportItem.validFrom
                                                      )
                                                    : null
                                            }
                                            disabled
                                        />
                                    </div>

                                    <div>
                                        <span>Valid to:</span>
                                        <DatePicker
                                            value={
                                                passportItem?.validTo
                                                    ? new Date(
                                                          passportItem.validTo
                                                      )
                                                    : null
                                            }
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            )}
        </Overlay>
    );
};

export default Modal;
